export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = 1048576;
